










import { computed, defineComponent } from "@vue/composition-api";
import useStateRedirectPath from "@/hooks/useStateRedirectPath";
import { useStaticPages } from "@/hooks/useStaticPages";

export default defineComponent({
  name: "FooterPolicy",
  props: {
    showContactUs: { type: Boolean, default: false },
  },
  setup(_, { root }) {
    const { stateRedirectPath } = useStateRedirectPath();
    const { pages, getPages } = useStaticPages();
    const visiblePages = computed(() => pages.value?.filter(page => page.visible) ?? []);
    const contactUsLocation = computed(() => root.$router.resolve({ name: "messages", params: { userId: "1" } }));

    const contactClick = () => {
      stateRedirectPath.value = contactUsLocation.value?.location ?? null;
      root.$router.push({ name: "login" });
    };

    getPages();

    return { visiblePages, contactUsLocation, contactClick };
  },
});
